// src/utils/logout.js
export function logout() {
    // Clear everything from localStorage
    localStorage.clear();
    // Redirect to login page
    window.location.href = "/login";
  }
  